import config from '../../config'

export function thumbnailUrl(flyer) {
    return [
        config.REACT_APP_API_HOST_NAME,
        'impression',
        'district',
        flyer.district_id,
        'flyer',
        `${flyer.flyer_id}.jpg`,
    ].join('/')
}

export function pageImageUrl(flyer, pageNumber) {
    const disableDisclaimer = (flyer.seller_type.match(/\b(district|school)\b/ig)) ? `?disclaimer=false` : ''
    return [
        config.REACT_APP_API_HOST_NAME,
        'view',
        'district',
        flyer.district_id,
        'flyer',
        `${flyer.flyer_id}`,
        `${pageNumber}.jpg${disableDisclaimer}`,
    ].join('/')
}



// WEBPACK FOOTER //
// ./src/shared/utils/URLs.js